module.exports = __webpack_public_path__ + "assets/normal/images/ComEmpty_4.bd048f23.png";